<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.branch"
                          :label="labels.branch"
                          :error-messages="errors.collect('branch')"
                          data-vv-name="branch"
                          :data-vv-as="labels.branch"
                          data-vv-scope="filters"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.fund"
                          :label="labels.fund"
                          :error-messages="errors.collect('fund')"
                          data-vv-name="fund"
                          :data-vv-as="labels.fund"
                          data-vv-scope="filters"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.acctNoSfx"
                          :label="labels.acctNoSfx"
                          :error-messages="errors.collect('acctNoSfx')"
                          data-vv-name="acctNoSfx"
                          :data-vv-as="labels.acctNoSfx"
                          data-vv-scope="filters"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glAcctNoDebtCtrl"
                          :label="labels.glAcctNoDebtCtrl"
                          :error-messages="errors.collect('glAcctNoDebtCtrl')"
                          data-vv-name="glAcctNoDebtCtrl"
                          :data-vv-as="labels.glAcctNoDebtCtrl"
                          data-vv-scope="filters"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glAcctNoDiffEx"
                          :label="labels.glAcctNoDiffEx"
                          :error-messages="errors.collect('glAcctNoDiffEx')"
                          data-vv-name="glAcctNoDiffEx"
                          :data-vv-as="labels.glAcctNoDiffEx"
                          data-vv-scope="filters"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glAcctNoRevalue"
                          :label="labels.glAcctNoRevalue"
                          :error-messages="errors.collect('glAcctNoRevalue')"
                          data-vv-name="glAcctNoRevalue"
                          :data-vv-as="labels.glAcctNoRevalue"
                          data-vv-scope="filters"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="showMore">
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glAcctNoWoff"
                          :label="labels.glAcctNoWoff"
                          :error-messages="errors.collect('glAcctNoWoff')"
                          data-vv-name="glAcctNoWoff"
                          :data-vv-as="labels.glAcctNoWoff"
                          data-vv-scope="filters"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glAcctNoInGst"
                          :label="labels.glAcctNoInGst"
                          :error-messages="errors.collect('glAcctNoInGst')"
                          data-vv-name="glAcctNoInGst"
                          :data-vv-as="labels.glAcctNoInGst"
                          data-vv-scope="filters"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glAcctNoOutGst"
                          :label="labels.glAcctNoOutGst"
                          :error-messages="errors.collect('glAcctNoOutGst')"
                          data-vv-name="glAcctNoOutGst"
                          :data-vv-as="labels.glAcctNoOutGst"
                          data-vv-scope="filters"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click.native="showMore = true" v-if="!showMore">Show More Filters</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-1"></v-spacer>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New GL Debtors Control
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="white--text" v-on="on">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox
                  v-for="column in columns"
                  :key="column.value"
                  :label="column.text"
                  :value="column.value"
                  v-model="selectedColumns"
                ></v-checkbox>
              </template>
              <template v-else> No column found </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-card-title>
      <v-data-table
        :headers="listHeaders"
        :items="items"
        v-bind:options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        :no-data-text="noDataText"
      >
        <template v-slot:item="row"
          ><tr>
            <td v-for="column in selectedColumns" :key="column">
              {{ row.item[column] }}
            </td>
            <td class="table-action-header">
              <table-action
                :rowData="row"
                review
                @review="doReview(row.item)"
                query
                @query="doQuery(row.item)"
                remove
                @remove="doDelete(row.item)"
              ></table-action>
            </td></tr
        ></template>
      </v-data-table>
      <confirm ref="confirmDelete">
        Are you sure you want to delete the selected GL Debtors Control record? ({{ selected.branch }}, {{ selected.fund }}, {{ selected.acctNoSfx }})
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      columns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Fund', value: 'fund' },
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Debtors Control', value: 'glAcctNoDebtCtrl' },
        { text: 'Realised', value: 'glAcctNoDiffEx' },
        { text: 'Revalue', value: 'glAcctNoRevalue' },
        { text: 'Write-Off', value: 'glAcctNoWoff' },
        { text: 'Input GST', value: 'glAcctNoInGst' },
        { text: 'Output GST', value: 'glAcctNoOutGst' }
      ],
      selectedColumns: ['branch', 'fund', 'acctNoSfx', 'glAcctNoDebtCtrl', 'glAcctNoDiffEx'],
      labels: {
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        glAcctNoDebtCtrl: 'Debtors Control',
        glAcctNoDiffEx: 'Realised',
        glAcctNoRevalue: 'Revalue',
        glAcctNoWoff: 'Write-Off',
        glAcctNoInGst: 'Input GST',
        glAcctNoOutGst: 'Output GST'
      },
      filters: {
        branch: null,
        fund: null,
        acctNoSfx: null,
        glAcctNoDebtCtrl: null,
        glAcctNoDiffEx: null,
        glAcctNoRevalue: null,
        glAcctNoWoff: null,
        glAcctNoInGst: null,
        glAcctNoOutGst: null
      },
      showMore: false,
      totalItems: 0,
      selected: {
        branch: null,
        fund: null,
        acctNoSfx: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.menu.getGLDebtCtrlList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((glDebtCtrl) => {
                const convertList = {
                  branch: glDebtCtrl.branch,
                  fund: glDebtCtrl.fund,
                  acctNoSfx: glDebtCtrl.acctNoSfx,
                  glAcctNoDebtCtrl: glDebtCtrl.glAcctNoDebtCtrl,
                  glAcctNoDiffEx: glDebtCtrl.glAcctNoDiffEx,
                  glAcctNoRevalue: glDebtCtrl.glAcctNoRevalue,
                  glAcctNoWoff: glDebtCtrl.glAcctNoWoff,
                  glAcctNoInGst: glDebtCtrl.glAcctNoInGst,
                  glAcctNoOutGst: glDebtCtrl.glAcctNoOutGst
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'glDebtCtrlDet',
        params: {
          id: 'new',
          glDebtCtrlMode: 'New'
        }
      })
    },
    doReview(data) {
      if (data) {
        const id = data.branch + '_' + data.fund + '_' + data.acctNoSfx
        this.$router.push({
          name: 'glDebtCtrlDet',
          params: {
            id,
            glDebtCtrlMode: 'Review'
          }
        })
      }
    },
    doQuery(data) {
      if (data) {
        const id = data.branch + '_' + data.fund + '_' + data.acctNoSfx
        this.$router.push({
          name: 'glDebtCtrlDet',
          params: {
            id,
            glDebtCtrlMode: 'Query'
          }
        })
      }
    },
    doDelete(data) {
      const apiURI = this.menu.deleteGLDebtCtrl
      if (data && apiURI) {
        this.selected.branch = data.branch
        this.selected.fund = data.fund
        this.selected.acctNoSfx = data.acctNoSfx
        this.$refs.confirmDelete.doPopUp().then((result) => {
          if (result) {
            this.$http
              .delete(expandURI(apiURI, this.selected))
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchData(false)
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        })
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filters').then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.branch = null
      this.filters.fund = null
      this.filters.acctNoSfx = null
      this.filters.glAcctNoDebtCtrl = null
      this.filters.glAcctNoDiffEx = null
      this.filters.glAcctNoRevalue = null
      this.filters.glAcctNoWoff = null
      this.filters.glAcctNoInGst = null
      this.filters.glAcctNoOutGst = null
      this.fetchData(false)
    }
  },
  computed: {
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    menu() {
      return this.$store.state.glAcctParam.menu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
